export default __webpack_public_path__ + "static/media/nowhere.0acb68de.glb";